// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form-Inputs_formContainer__Eqo1I {
  display: grid;
  margin-top: 45px;
  grid-template-columns: 1fr 4fr;
  gap: 30px;
}

.Form-Inputs_formNavSection__9IEW\\+ {
  background-color: var(--branded-darker-gray);
  color: var(--branded-light-gray);
  border-radius: 5px;
  padding: 30px 10px;
}

.Form-Inputs_form__V1bVe {
  padding: 0;
}

.Form-Inputs_formTitle__oXjxV {
  margin: 0 0 15px 0;
}

.Form-Inputs_formDesc__zV4aG {
  font-size: medium;
  margin-bottom: 30px;
}

.Form-Inputs_blockWrapper__ndCyw {
  display: flex;
  flex-direction: column;
}

.Form-Inputs_block__3sEbO {
  position: relative;
  padding: 10.5px;
  border-radius: 5px;
  background-color: #eff3f8;
  color: #495057;
  font-weight: 400;
  font-size: 12px;
  line-height: 16.34px;
}
.Form-Inputs_noteBlock__apQPn {
  padding: 0px;
  color: #495057;
  font-size: 12px;
  font-weight: 400;
  border: 1px solid var(--branded-light-purple);
}

.Form-Inputs_pageSummary__Y6zE4 {
  font-size: small;
  text-align: center;
  margin-bottom: 30px;
}

.Form-Inputs_toogleAll__6UphX {
  text-align: right;
  margin-bottom: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.8em;
  color: var(--blue);
}

.Form-Inputs_toogle__kuIeK {
  font-size: 2em;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.Form-Inputs_fieldsWrapper__e\\+9zQ {
  margin: 15px 0 15px 0;
  display: flex;
  flex-direction: column;
}

.Form-Inputs_fieldsWrapperCollapse__bQjPQ {
  margin: 0;
  height: 0;
}

.Form-Inputs_blockTitle__512pW {
  margin: 0;
}

.Form-Inputs_hidden__kqB1Q {
  display: none;
}

.Form-Inputs_field__Z4DQF {
  color: #495057;
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  margin-bottom: 15px;
}

.Form-Inputs_skeletonTitle__sxIax {
  margin-bottom: 15px;
}

.Form-Inputs_skeletonLabel__xOXHq {
  margin-bottom: 5px;
}

.Form-Inputs_label__l9eDZ {
  display: block;
  color: #495057;
  font-weight: 700;
  font-size: 12px;
  line-height: 16.34px;
  margin-bottom: 5px;
}

.Form-Inputs_errFieldMsg__ekFLr {
  font-size: small;
  color: var(--branded-error-red) !important;
}

.Form-Inputs_remove_pic_btn__Qe5fU {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 16px;
  height: 16px;
  padding: 0;

  .pi {
    font-size: 10px !important;
  }
}
.Form-Inputs_info__A25XR:hover {
  cursor: pointer;
}
.Form-Inputs_infoIcon__RRDQW {
  margin-left: 0.5rem;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Form-Inputs.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;;EAEV;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".formContainer {\n  display: grid;\n  margin-top: 45px;\n  grid-template-columns: 1fr 4fr;\n  gap: 30px;\n}\n\n.formNavSection {\n  background-color: var(--branded-darker-gray);\n  color: var(--branded-light-gray);\n  border-radius: 5px;\n  padding: 30px 10px;\n}\n\n.form {\n  padding: 0;\n}\n\n.formTitle {\n  margin: 0 0 15px 0;\n}\n\n.formDesc {\n  font-size: medium;\n  margin-bottom: 30px;\n}\n\n.blockWrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.block {\n  position: relative;\n  padding: 10.5px;\n  border-radius: 5px;\n  background-color: #eff3f8;\n  color: #495057;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16.34px;\n}\n.noteBlock {\n  padding: 0px;\n  color: #495057;\n  font-size: 12px;\n  font-weight: 400;\n  border: 1px solid var(--branded-light-purple);\n}\n\n.pageSummary {\n  font-size: small;\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.toogleAll {\n  text-align: right;\n  margin-bottom: 15px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 0.8em;\n  color: var(--blue);\n}\n\n.toogle {\n  font-size: 2em;\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n}\n\n.fieldsWrapper {\n  margin: 15px 0 15px 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.fieldsWrapperCollapse {\n  margin: 0;\n  height: 0;\n}\n\n.blockTitle {\n  margin: 0;\n}\n\n.hidden {\n  display: none;\n}\n\n.field {\n  color: #495057;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 100%;\n  margin-bottom: 15px;\n}\n\n.skeletonTitle {\n  margin-bottom: 15px;\n}\n\n.skeletonLabel {\n  margin-bottom: 5px;\n}\n\n.label {\n  display: block;\n  color: #495057;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16.34px;\n  margin-bottom: 5px;\n}\n\n.errFieldMsg {\n  font-size: small;\n  color: var(--branded-error-red) !important;\n}\n\n.remove_pic_btn {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n\n  :global(.pi) {\n    font-size: 10px !important;\n  }\n}\n.info:hover {\n  cursor: pointer;\n}\n.infoIcon {\n  margin-left: 0.5rem;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `Form-Inputs_formContainer__Eqo1I`,
	"formNavSection": `Form-Inputs_formNavSection__9IEW+`,
	"form": `Form-Inputs_form__V1bVe`,
	"formTitle": `Form-Inputs_formTitle__oXjxV`,
	"formDesc": `Form-Inputs_formDesc__zV4aG`,
	"blockWrapper": `Form-Inputs_blockWrapper__ndCyw`,
	"block": `Form-Inputs_block__3sEbO`,
	"noteBlock": `Form-Inputs_noteBlock__apQPn`,
	"pageSummary": `Form-Inputs_pageSummary__Y6zE4`,
	"toogleAll": `Form-Inputs_toogleAll__6UphX`,
	"toogle": `Form-Inputs_toogle__kuIeK`,
	"fieldsWrapper": `Form-Inputs_fieldsWrapper__e+9zQ`,
	"fieldsWrapperCollapse": `Form-Inputs_fieldsWrapperCollapse__bQjPQ`,
	"blockTitle": `Form-Inputs_blockTitle__512pW`,
	"hidden": `Form-Inputs_hidden__kqB1Q`,
	"field": `Form-Inputs_field__Z4DQF`,
	"skeletonTitle": `Form-Inputs_skeletonTitle__sxIax`,
	"skeletonLabel": `Form-Inputs_skeletonLabel__xOXHq`,
	"label": `Form-Inputs_label__l9eDZ`,
	"errFieldMsg": `Form-Inputs_errFieldMsg__ekFLr`,
	"remove_pic_btn": `Form-Inputs_remove_pic_btn__Qe5fU`,
	"info": `Form-Inputs_info__A25XR`,
	"infoIcon": `Form-Inputs_infoIcon__RRDQW`
};
export default ___CSS_LOADER_EXPORT___;
